/* CreateNewAdhocQueryRenderer.js */

"use strict";
const _ = require("lodash");
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;

class CreateNewAdhocQueryRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("capture-name-gl"); //TODO Setup the root Element
        this._rootElem.component = this._model;

        this._nameField = new InputTextControl({
            darkTheme: true,
            placeholder: "Enter a name for this Query"
        });

        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true
        });

        this._saveButton = new ButtonControl({
            label: "Save",
            darkTheme: true,
            theme: "additive",
            disabled: true
        });

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model.titleText;

        this._buttonContainer = document.createElement("button-container");

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._cancelButton.on("UserClick", (this._onCancelButtonClick = this._onCancelButtonClick.bind(this)));
        this._saveButton.on("UserClick", (this._onSaveButtonClick = this._onSaveButtonClick.bind(this)));
        this._nameField.on("UserValue", (this._onUserValue = this._onUserValue.bind(this)));
        this._model.on("error", (this._onError = this._onError.bind(this)));
    }

    _unregisterListeners() {
        this._cancelButton.removeAllListeners("UserClick");
        this._saveButton.removeAllListeners("UserClick");
        this._nameField.removeAllListeners("UserValue");
        this._model.removeAllListeners("error");
    }

    _onError(error) {
        this._nameField.setInvalid(true);
        this._nameField._renderer._errorSpan.innerText = typeof error === "string" ? error : error.errorMsg;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        let promArr = [this._nameField.shutdown(), this._cancelButton.shutdown(), this._saveButton.shutdown()];

        return Promise.all(promArr).then(
            () => {
                this._nameField = undefined;
                this._cancelButton = undefined;
                this._saveButton = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "CreateQuestionRenderer.shutdown() error");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleComponent);
                this._rootElem.appendChild(this._nameField.renderer.rootElement);
                this._rootElem.appendChild(this._buttonContainer);
                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._saveButton.renderer.rootElement);
                setTimeout(() => {
                    this._nameField.focus();
                });
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    // TODO Private Render Methods here

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onCancelButtonClick() {
        this.model.cancelAction();
    }

    _onSaveButtonClick() {
        this._model.saveNewQuery(this._nameField.getValue());
    }

    _onUserValue(value) {
        if (!_.isEmpty(value.trim())) {
            this._saveButton.setDisabled(false);
        } else {
            this._saveButton.setDisabled(true);
        }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = CreateNewAdhocQueryRenderer;
